<template>
  <div v-if="getPermission.ccic.view || getPermission.stc.view">  



  <md-dialog :md-active.sync="isPictureModalShowing">
    <md-dialog-content>
      <span class="heading2">{{photoTitle}}</span>
      <calling-api path="/api/w/ccr/photo/getCCRPhoto">
      <div v-if="photos.length === 0">
        <h3>You don't have any photos from CCR Log</h3>
      </div>
      <div v-else>
        <view-image  :key="p.imgUrl" :src="p.imgUrl" v-for="p in photos">
         <div v-if="!isLoading" class="space">
            <h3>Type: {{p.title}}</h3>
            <p>File Name: {{getPhotoName(p)}}</p>
          </div>
          <div v-if="isLoading" class="space">
            <p>File Name: {{getPhotoName(p)}}</p>
            <p>{{p.refTimeStamp}}</p>
          </div>            
        </view-image>
      </div>
        
      </calling-api>
    </md-dialog-content>
    <md-dialog-actions>
      <download-pictures-button :zip-file-name="photoZipFileName"
                                :file-prefix-for-each-file="filePrefixForEachFile"
                                :pics="photos.map(it=>it.photoUrl)"
                                v-if="isLoading"/>
      <md-button class="md-primary" @click="isPictureModalShowing = false; isLoading = false;">Close</md-button>      </md-dialog-actions>
  </md-dialog>


    <md-dialog :md-active.sync="isFilterModalShowing">
      <md-dialog-content>
        <h1>Additional Search</h1>
        
        <!-- 1 -->
        <div class = "inputBoxDouble" > 
          <!-- <div class = "inputBoxSpace" > 
            <auto-complete-master-data-select
              label="Stage Type"
              display-type="idOnly"
              :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_STAGE_TYPE')"
              :init-value-id="searchRequest.stageType"
              :on-item-changed="handleTypeChanged">
            </auto-complete-master-data-select>
          </div> -->
          <!-- <div class = "inputBoxSpace">
            <md-field>
              <label>Freight Type</label>
              <md-input v-model="searchRequest.freightType"/>
            </md-field>
          </div> -->

          <!-- <div class = "inputBoxSpace" >
            <auto-complete-master-data-select
              group="GST_CTNRTYPE"
              label="Container Type"
              :init-value="searchRequest.ctnrType"
              :on-item-changed="handleCtnrTypeChanged">
            </auto-complete-master-data-select>
          </div> -->

          <!-- <div class = "inputBoxSpace">
            <auto-complete-master-data-select
              group="PUSH_STATUS"
              label="Push Status"
              :init-value="searchRequest.pushStatus"
              :on-item-changed="handlePushStatusChanged">
            </auto-complete-master-data-select>
          </div> -->
        </div>

        <!-- 2 -->
        <div class = "inputBoxDouble" > 
          <div class = "inputBoxSpace" >
            <datepicker v-model="searchRequest.apptDate.startDate" >
              <label>Appt.From</label>
            </datepicker>
          </div>

          <div class = "inputBoxSpace" >
            <datepicker v-model="searchRequest.apptDate.endDate">
              <label>Appt.To</label>
            </datepicker>
          </div>

          <div class = "inputBoxSpace" >
            <datepicker v-model="searchRequest.cargoCutOff.startDate" >
              <label>CargoCut From</label>
            </datepicker>
          </div>

          <div class = "inputBoxSpace" >
            <datepicker v-model="searchRequest.cargoCutOff.endDate">
              <label>CargoCut To</label>
            </datepicker>
          </div>
        </div>


        <!-- 3 -->
        <div class = "inputBoxDouble" > 


          <div class = "inputBoxSpace">
            <md-field>
              <label>Delivery Order</label>
              <md-input v-model="searchRequest.deliveryOrder"/>
            </md-field>
          </div>

          <div class = "inputBoxSpace">
            <md-field>
              <label>Customer PO</label>
              <md-input v-model="searchRequest.customerOrder"/>
            </md-field>
          </div>

          <div class = "inputBoxSpace">
            <md-field>
              <label>Appointment</label>
              <md-input v-model="searchRequest.appointment"/>
            </md-field>
          </div>


          <div class = "inputBoxSpace">
            <md-field>
              <label>Pick up Location</label>
              <md-input v-model="searchRequest.pickupLocation"/>
            </md-field>
          </div>
    


          <div class = "inputBoxSpace">
            <md-field>
              <label>Destination</label>
              <md-input v-model="searchRequest.destination" />
            </md-field>
          </div>

<div class = "inputBoxSpace">
            <auto-complete-master-data-select
              group="DriverGroup"
              label="Driver Group"
              :init-value="searchRequest.driverGroup"
              :on-item-changed="handleDrGroupChanged">
            </auto-complete-master-data-select>
</div>

<div class = "inputBoxSpace">
            <auto-complete-master-data-select
              :prepared-options="drivers"
              label="Driver"
              :init-value="searchRequest.driver"
              :on-item-changed="handleDriverRequestChanged">
            </auto-complete-master-data-select>
  </div>

 
            <div class = "inputBoxSpace">
              <auto-complete-master-data-select
                label="Carrier Name"
                display-type="idOnly"
                :prepared-options="this.getMasterDataAsSelectOptionByGroup('STC_CARRIER')"
                :init-value-id="searchRequest.carrier"
                :on-item-changed="handleCarrierChanged">
              </auto-complete-master-data-select>
            </div>
   

        </div>
      </md-dialog-content>
    </md-dialog>




    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div  v-if="active" class="md-layout-item md-size-15 md-small-size-50">
            <div class = "inputBoxSpace1" >
               <auto-complete-master-data-select
                  group="REC_WINDOW"
                  label="Rev. Windows"
                  :init-value="searchRequest.receivingWindow"
                  :on-item-changed="handleWindowsChanged">
               </auto-complete-master-data-select>
            </div>
          </div>

<!-- 
          <div  v-if="active" class="md-layout-item md-size-15 md-small-size-50">
          <div class = "inputBoxSpace1" >
            <datepicker v-model="searchRequest.moveInDate.startDate" >
              <label>MoveIn.From</label>
            </datepicker>
          </div>
            </div>
 



          <div  v-if="active" class="md-layout-item md-size-15 md-small-size-50">
          <div class = "inputBoxSpace1" >
            <datepicker v-model="searchRequest.moveInDate.endDate">
              <label>MoveIn.To</label>
            </datepicker>
          </div>
            </div> -->
    



          <div v-if="active" class = "inputBoxSpace1">
            <auto-complete-master-data-multiple-select
                label="Load Status"
                :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_LOAD_STATUS')"
                v-model="searchRequest.loadStatus"
            />
          </div>

          <!-- <div  v-if="active" class="md-layout-item md-size-15 md-small-size-50">
            <div class = "inputBoxSpace1">
                  <md-field>
                    <label size="lg" class = "textlabel" for="loadStatus">Load Status</label>
                      <md-select v-model="searchRequest.loadStatus">
                      <md-option value="ASN">Load Assigned</md-option>
                      <md-option value="DCP">Load Completed</md-option>
                      <md-option value="CFM">Load Conform</md-option>
                      <md-option value="BLC">AP/AR Conform</md-option>
                      <md-option value="LOC">AP/AR Locked</md-option>
                    </md-select>
                  </md-field>
            </div>
          </div>  -->

          <div  v-if="active" class="md-layout-item md-size-15 md-small-size-50">
              <div class = "inputBoxSpace1" >
              <auto-complete-master-data-select
                                                group="GST_STAGE_STATUS"
                                                label="Stage Status"
                                                :init-value="searchRequest.stageStatus"
                                                :on-item-changed="handleStageStatusChanged"
                                                >
              </auto-complete-master-data-select>
            </div>
          </div>
          
          <!-- <div  v-if="active" class="md-layout-item md-size-15 md-small-size-50">
            <div class = "inputBoxSpace1">
                  <md-field>
                    <label size="lg" class = "textlabel" for="stageStatus">Stage Status</label>
                      <md-select v-model="searchRequest.stageStatus">
                      <md-option value="ASG">Stage Assigned</md-option>
                      <md-option value="CFM">Stage Conform</md-option>
                      <md-option value="CCO">AP Conform</md-option>
                      <md-option value="LOK">AP Locked</md-option>
                    </md-select>
                  </md-field>
            </div>
          </div>   -->


        <div  v-if="active" class="md-layout-item md-size-10 md-small-size-100">
          <md-button
            class="custButtonFilter md-raised"
            @click="filterBar"> <span class="icons-center material-icons">find_in_page</span>
            More
          </md-button>
        </div>


        <div v-if="getPermission.ccic.edit || getPermission.stc.view" class="md-layout-item md-size-100 md-small-size-100">
          <callingApiCenter :paths="['/api/w/gst/yardexportlist', '/api/w/gst/WebSearchDispatchList', '/api/w/stc/dispatchstagelist']">
            <callingApiCenter path=" /api/w/gst/loadlist/create" :not-display-error="true">
             <b-notification class = "notifySize"
                type="is-success"
                v-model="notifyActive"
                aria-close-label="Close notification">
                {{notifyMessage}}
             </b-notification>

             <md-button class="md-raised custMedButton" :disabled="!canEdit" @click="doCockPit" ><span class="icons-center material-icons"  >create</span>Detail</md-button>
             <md-button id = "searchTag" @click="doSearch"  class=" custButton btn-search-special-form-container md-primary md-raised">Search</md-button>
             <md-button   @click="doClear" class="md-raised custButton">Clear</md-button>
           <input class = "custSearchBar" type="text"
                  placeholder="Searching Term"
                  v-model="filter"

                  />
          <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
            <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
            <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
          </md-button>
            </callingApiCenter>
          </callingApiCenter>
        </div>
      </div>
    </md-card-content>
  </md-card>

      <pagination :items="filteredRows">
    <template slot-scope="{pageItems}">
      <md-card class="data-table-container">
        <div class="outer-container ">
          <div class="inner-container table-wrapper ">
            <div class="table-header">
              <table id="headertable">
                <thead>
                <tr>
                  <th class="header-cell w2">
                    <!-- <md-checkbox v-model="selectAll" @change="changeSelChkBox"></md-checkbox> -->
                    <!-- <md-tooltip md-direction="top">Select All/DeSelect All</md-tooltip> -->
                  </th>
                    <th class="header-cell center w5" v-on:click="sortFunction('receivingWindows')">Receiving Window</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('loadKeyWithStageNo')">StageKey</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('moveInDate')">moveInDate</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('loadStatus')">Load Status</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stageStatus')">Stage Status</th>
                    <!--<th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load Key</th>-->
                    <th class="header-cell center w8" v-on:click="sortFunction('containerNo')">Container</th>
                    <th class="header-cell center w8" v-on:click="sortFunction('chassisNo')">Chassis</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('carrier')">Carrier</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stage')">Stage#</th>   
                    <th class="header-cell center w5" v-on:click="sortFunction('stageType')">Stage Type</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('freightType')">Freight Type</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('costRelevant')">Cost Relevant</th> 
                    <th class="header-cell center w10" v-on:click="sortFunction('dispatcherInstruction')">Stage Dispatcher Instruction</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('bookingNo')">Booking</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('cutLDF')">Cargo Cut-off</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('dropOffTml')">Drop Off Tml</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('appointment')">Apointment</th>
                    <th class="header-cell center w10" v-on:click="sortFunction('apptDate')">Appt Date</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('apptTime')">Appt Time</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('driverGroup')">Driver Group</th>
                    <th class="header-cell center w10" v-on:click="sortFunction('driver')">Driver</th>
                    <th class="header-cell center w10" v-on:click="sortFunction('driverId')">Container Image</th>
                    <th class="header-cell center w10" v-on:click="sortFunction('pushStatus')">Push Status</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">CTN Type</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">Source</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">Used Day</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">CHZ End Date</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('loadKey')">Load Key</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('yardLoc')">Yard Loc.</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">STC DO</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('customerOrder')">CustPO</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('doProcess')">DO Process</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('sealNo')">Seal#</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('weightTicket')">Weight Ticket</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('pickUpLoc')">PickUp Loc.</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('pickUpTml')">PickUp Tml</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('DeliveryTo')">Delivery To</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('truckId')">Truck ID</th>
                    <th class="header-cell center w10" v-on:click="sortFunction('truckId')">Dispatch Instruction</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('do')">Route#</th>

                </tr>
                </thead>
              </table>
            </div>
            <div class="table-body" @scroll="handleScroll">
              <table id="bodytable">
                <tbody>
                  <tr :key="item.vueKey" v-for="item in pageItems" 
                        v-bind:class ="{ selected: item.selected }">
                   <td class="body-cell w2 ">
                    <md-checkbox v-model="item.selected">
                      <span v-if="hasBeenChanged(item)">*</span>
                    </md-checkbox>
                  </td>
                  <td class="body-cell excelBox w5">{{item.receivingWindow}}</td>
                  <td class="body-cell excelBox w5">{{item.loadKeyWithStageNo}}</td>
                  <td class="body-cell excelBox w5">{{item.moveInDate | date}}</td>
                  <td class="body-cell excelBox w5">{{item.loadStatus}}</td>
                  <td class="body-cell excelBox w5">{{item.stageStatus}}</td>
                  <!--<td class="body-cell excelBox w5">{{item.seqNo}}</td>-->
                  <td class="body-cell excelBox w8">{{item.containerNo}}</td>
                  <td class="body-cell excelBox w8">{{item.chassisNo}}</td>
                  <td class="body-cell excelBox w5">{{item.carrier}}</td>
                  <td class="body-cell excelBox w5">{{item.stage}}</td>
                  <td class="body-cell excelBox w5">{{item.stageType}}</td>
                  <td class="body-cell excelBox w5">{{item.freightType}}</td>
                  <td class="body-cell excelBox w5">{{item.costRelevant}}</td>
                  <td class="body-cell excelBox w10">{{item.stageDispatcherInstruction}}</td>
                  <td class="body-cell excelBox w5">{{item.bookingNo}}</td>
                  <td class="body-cell excelBox w5">{{item.cutLFD}}</td>
                  <td class="body-cell excelBox w5">{{item.dropOffTml}}</td>
                  <td class="body-cell excelBox w5">{{item.appointment}}</td>
                  <td class="body-cell excelBox w10">{{item.apptDate | date}}</td>
                  <td class="body-cell excelBox w5">{{item.apptTime}}</td>
                  <td class="body-cell excelBox w5">{{item.driverGroup}}</td>
                  <td class="body-cell excelBox w10">
                    <template v-if="isAsgDriver && chkItemPushStatus(item)">
                       <auto-complete-select
                                :options="drivers"
                                :value="item.driverId"
                                :on-item-change="changeAsgDriverId(item)"
                        ></auto-complete-select>        
                    </template>
                    <template v-else>
                    {{item.driver}}
                    </template>
                  </td>
                  <td class="body-cell excelBox w10">
                    <template v-if="item.driverCntrImg != null">
                        <a href="" @click.prevent="toggleItemLink(item)">
                          1 image
                        </a>  
                      </template>  
                      <template v-else>
                          0 image
                      </template>  
                  </td>
                  <td class="body-cell excelBox w10">{{getPushStatusInfo(item.pushStatus)}}</td>
                  <td class="body-cell excelBox w5">{{item.ctnrType}}</td>
                  <td class="body-cell excelBox w5">{{item.source}}</td>
                  <td class="body-cell excelBox w5">{{getChassisUsedDate(item)}} Days</td>
                  <td class="body-cell excelBox w5">{{item.chzEndDate}}</td>
                  <td class="body-cell excelBox w5">{{item.loadKey}}</td>
                  <td class="body-cell excelBox w5">{{item.yardLoc}}</td>
                  <td class="body-cell excelBox w5">{{item.deliveryOrder}}</td>
                  <td class="body-cell excelBox w5">{{item.customerOrder}}</td>
                  <td class="body-cell excelBox w5">{{item.doProcess}}</td>
                  <td class="body-cell excelBox w5">{{item.sealNo}}</td>
                  <td class="body-cell excelBox w5">{{item.weightTicket}}</td>
                  <td class="body-cell excelBox w5">{{item.pickUpLoc}}</td>
                  <td class="body-cell excelBox w5">{{item.pickUpTml}}</td>
                  <td class="body-cell excelBox w5">{{item.deliveryTo}}</td>
                  <td class="body-cell excelBox w5">{{item.truckId}}</td>
                  <td class="body-cell excelBox w10">{{item.dispatchInstuction}}</td>
                  <td class="body-cell excelBox w5">{{item.route}}</td>

                 </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </md-card>
    </template>
  </pagination>
  </div>





</template>


<style scoped>


.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }
.icons-center {
  vertical-align: middle;
  margin-right: 10px;
}
.inputBox {
  border: 1px solid #cacbcc;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
}
.inputBox:hover {

  border: 2px solid #448aff;
  border-radius: 5px;
  color: #29303b;
  font-size: 18px;
  height: auto;
  line-height: 1em;
  padding: 5px 5px 5px 5px;
  margin-top: 6px;
  background-color: #e0eff7;
    
}

.selected {
   background: #726a95;
}
.tableW {
  height: 40px;
}
.center {
  text-align: center;
}

tr:hover {
  background: #c8e6f5;
}


.modal {
   background-color: #29303b;
    border-radius: 5px;
}
.modalTitle {
  font-weight: normal;
  font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
  font-weight: 500;
  color: white;
  font-family: Poppins, sans-serif;
  margin-bottom: 0.5rem;
  line-height: 1.6;
}
.md-menu {
padding: 0;
padding: 0;

}
.custButton {
  margin: 10px;
  width: 90px;
  height: 36px;
  line-height:20px;
  font-size: 0.8rem;
}
.custMedButton {
  margin: 10px;
  width: 110px;
  height: 36px;
  line-height:20px;
  font-size: 0.8rem;
}
.custMenuButton {
  
  width: 110px;
  height: 40px;
  line-height:45px;
  font-size: 0.9rem;
  align-self: center;
}
.custSearchBar{
    margin: 10px;
  width: 200px;
  height: 40px;
  line-height:40px;
  font-size: 0.9rem;
}
.custButtonRight {
  margin: 10px;
  width: 100px;
  height: 40px;
  float : right;
}



</style>



<script>
/* eslint-disable no-plusplus */
import { mapGetters } from 'vuex';
import dateFormat from '../utils/dateFormat';
//import api from "../api";
import { newAPIPost } from '../api';
import CcicPhotoForm from "../components/CcicPhotoForm.vue";
import callingApiCenter from "../components/CallingApiCenter.vue";
import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";


const getInitSearch = () => ({
  users: [],
  teams: [],
  receivingWindow: null,
  salesOffice: null,
  pickupLocation: null,
  bookingNo: null,
  destination: null,
  appointment: null,
  driver: null,
  driverGroup: null,
  costRelevant: null,
  freightType: null,
  


  cargoCutOff: {
    startDate: null,
    endDate: null,
  },
  apptDate: {
    startDate: null,
    endDate: null,
  },
 
  moveInDate: {
    startDate: null,
    endDate: null,
  },

  loadKey: null,
  source: null,
  containerNo: null,
  chassisNo: null,
  carrier: null,
  customerOrder: null,
  deliveryOrder: null,
  loadStatus: ["DCP","ASN"],
  stageStatus: null,
  //selected: false,
  pushStatus: null,
  stageType: null, 
  forStage: true
});

const initSearchCriteria = () => ({
    receivingWindow: null,
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driver: null,
    driverGroup: null,
    costRelevant: null,
    freightType: null,
    moveInDate: {
      startDate: null,
      endDate: null,
    },
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    apptDate: {
      startDate: null,
      endDate: null,
    },
    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    customerOrder: null,
    deliveryOrder: null,
    loadStatus: [],
    pushStatus: null,
    stageType: null,
    fromPage: null
 
})

const initDispatchLoadSearch = () => ({
    receivingWindow: null,
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driverId: null,
    driverGroup: null,
    costRelevant: null,
    freightType: null,
    moveInDate: {
      startDate: null,
      endDate: null,
    },
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    apptDate: {
      startDate: null,
      endDate: null,
    },
    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    customerOrder: null,
    deliveryOrder: null,
    loadStatus: [],
    pushStatus: null,
    stageType: null,
    filter: null,
    fromPage: null
})

const initCockpitReq = () => ({
   mode: null,
   carrierName: null,
   customerOrder: null,
   route: null,
   deliveryOrder: null,
   loadKey: null,
   bookingNo: null
})

const getInitDriverSearch = () => ({
     source: null,
     driverOffice: null,
     defaultSalesOffice: null
  })

const initStageSearch = () => ({
    loadKey: null
})

export default {

  data: () => ({
    searchRequest: getInitSearch(),
    cockpitRequest: initCockpitReq(),
    searchDriverSearchReq: getInitDriverSearch(),
    searchCriteria: initSearchCriteria(),
    searchStage: initStageSearch(),
    dispatchLoadSearch: initDispatchLoadSearch(),
    active: false,
    drivers: [],
    items: [],
    selectedItems: [],
    dialog: {
      isShowing: false,
    },
    usersToSearch: [],
    modalMessage: "",  
    isWarning: false,
    active: false,
    sortStatus: true,
    filter: "",
    containerCopy: false,
    selectAll: false,
    notifyMessage: null,
    notifyActive: false,
    selectDType: null,
    isPictureModalShowing: false,
    photoZipFileName: '',
    filePrefixForEachFile: '',
    isLoading: false,
    isdownloadzip: false,
    imgPath: null,
    photoTitle: "Photos",
    photos: [],
    singleReq: [],
    isSetDriverGroup: false,
    isSetAppointment: false,
    isAsgDriver: false,
    disableSave: false,
    disableAppt: true,
    driverIds: [],
    driverNames: [],
    driverContent: [],
    stageList: [],
    isFilterModalShowing:false,
  }),


  components: {
    AutocompleteCcicLocationSelect,
    CcicPhotoForm,
    callingApiCenter,
  },

  watch: {


    getDispatchStageList(val) {
        this.updateItems(val);
    },

    // eslint-disable-next-line
    "searchRequest.teams"() {
       this.searchRequest.users = [];
    },
    notifyActive(val) {
      if (val == false)
      {
        this.notifyMessage = null;
      }
    },

  },

  computed: {
  ...mapGetters([
      'getMasterDataName',
      'getMasterDataByGroup',
      'getMasterDataAsSelectOptionByGroup',
      'getPermission',
      'getUserProfile',
      'getRole',
      'getYardExportList',
      'getImportLoadList',
      'getTruckLoadList',
      'getSTCDriverGroup',
      'getDirectExportList',
      'getDispatchStageList'
    ]),


    filteredRows(){
      return this.items.filter(row => {
        const term = this.filter.toUpperCase();
        return this.includeNull(row.containerNo).includes(term) ||
               this.includeNull(row.chassisNo).includes(term) ||
              //  this.includeNull(row.loadKey).includes(term)||
               this.includeNull(row.seqNo).includes(term)||
               this.includeNull(row.loadStatus).includes(term)||
               this.includeNull(row.stageStatus).includes(term)||
               this.includeNull(row.stageType).includes(term)||
               this.includeNull(row.bookingNo).includes(term);
      })
    },



    getSelectedItems() {
      return _(this.items)
        .filter(it => it.selected);
    },

    getEditingItems() {
      return _(this.items)
        .filter(it => it.editing);
    },

    getAssignBookingCond() {

      const items = _(this.items).filter((it) => it.selected);
      const LD = items.filter((it) => it.loadStatus == 'ASN');
      if (LD.length != 0) return false;
      const weighted = _(items).filter((it) => it.weight != null);
      if (items.length == 0) return false
      const ctnrType = [...new Set(items.map(s => s.ctnrType))];
      const grade = [...new Set(items.map(s => s.grade))];
      const carrier = [...new Set(items.map(s => s.carrier))];
      const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
      if (sapStatus.length == 0) return false
      console.log("grade: " + grade + ":" + grade.length + " ctnrType: " + ctnrType + ":" + ctnrType.length);
      return items.length === weighted.length && ctnrType.length === 1 && grade.length === 1

    },

    getUnAssignBookingCond() { 
       console.log("unassign cond");
       const item = _(this.items).filter((it) => it.selected);
       const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
       if (sapStatus.length == 0) return false
       console.log("unassign item length:" + item.length);
       return item.length === 1 && item[0].loadStatus == 'ASN'
    },

    getSelectedItems() {
      return _(this.items).filter((it) => it.selected);
    },


    canOutGate(){
      return this.getSelectedItems.length != 0
    },


    canEditSingle() {
       return this.getSelectedItems.length === 1 ;

    },

    canEditSingle() {
       return this.getSelectedItems.length === 1 ;
    

    },


    canEdit() {
      return this.getSelectedItems.length != 0 ;
    },


    canSave() {
      console.log("canSave: " + this.disableSave);
      return this.disableSave;
    },

    noGates(){
        if (this.getSelectedItems.length == 0)
        {
          return false
        }
        var gates = false
        this.getSelectedItems.forEach((it) => {
          if (it.loadKeyWithStageNo == null)
          {
            gates = true
          }
        });
        return !gates;
    },



    canDelete(){

      
      if (this.getSelectedItems.length != 1)
      {
        return false
      }

      if (this.getSelectedItems[0].stageStatus != null)
      {
        return false
      }

      return true


    },

    canDeleteBooking() {
      if (this.getSelectedItems.length != 1)
      {
        return false
      }

      if (this.getSelectedItems[0].deliveryOrder == null)
      {
        return false
      }

      return true
    },


    canDeleteLoad(){

      
      if (this.getSelectedItems.length != 1)
      {
        return false
      }

      if (this.getSelectedItems[0].stageStatus != null)
      {
        return false
      }

      if (this.getSelectedItems[0].loadStatus != "JO")
      {
        return false
      }

      return true


    },

    getDownloadCond() {
        const item = _(this.items).filter((it) => it.selected);
        if (item.length == 0 && this.items.length != 0) return this.items;

    },


  },

  async mounted() {
    this.doSearch();
    this.drivers = [];
    console.log("location")
    console.log(this.getMasterDataAsSelectOptionByGroup('GST_LOCATION'))
 
      this.stageList = JSON.parse(this.$route.params.req);
      var searchCriteria = JSON.parse(this.$route.params.searchCriteria);
      this.dispatchLoadSearch.containerNo = searchCriteria.containerNo;
      this.dispatchLoadSearch.receivingWindow = searchCriteria.receivingWindow;
      this.dispatchLoadSearch.salesOffice = searchCriteria.salesOffice;
      this.dispatchLoadSearch.pickUpLocation = searchCriteria.pickUpLocation;
      this.dispatchLoadSearch.bookingNo = searchCriteria.bookingNo;
      this.dispatchLoadSearch.destination = searchCriteria.destination;
      this.dispatchLoadSearch.appointment = searchCriteria.appointment;
      this.dispatchLoadSearch.driveId = searchCriteria.driverId;
      this.dispatchLoadSearch.driverGroup = searchCriteria.driverGroup;
      this.dispatchLoadSearch.costRelevant = searchCriteria.costRelevant;
      this.dispatchLoadSearch.freightType = searchCriteria.freightType;
      this.dispatchLoadSearch.moveInDate.startDate = searchCriteria.moveInDate.startDate;
      this.dispatchLoadSearch.moveInDate.endDate = searchCriteria.moveInDate.endDate;
      this.dispatchLoadSearch.cargoCutOff.startDate = searchCriteria.cargoCutOff.startDate;
      this.dispatchLoadSearch.cargoCutOff.endDate = searchCriteria.cargoCutOff.endDate;
      this.dispatchLoadSearch.apptDate.startDate = searchCriteria.apptDate.startDate;
      this.dispatchLoadSearch.apptDate.endDate = searchCriteria.apptDate.endDate;
      this.dispatchLoadSearch.loadKey = searchCriteria.loadKey;
      this.dispatchLoadSearch.source = searchCriteria.source;
      this.dispatchLoadSearch.chassisNo = searchCriteria.chassisNo;
      this.dispatchLoadSearch.carrier = searchCriteria.carrier;
      this.dispatchLoadSearch.customerOrder = searchCriteria.customerOrder;
      this.dispatchLoadSearch.deliveryOrder = searchCriteria.deliveryOrder;
      this.dispatchLoadSearch.doProcess = searchCriteria.doProcess;
      this.dispatchLoadSearch.loadStatus = searchCriteria.loadStatus;
      this.dispatchLoadSearch.pushStatus = searchCriteria.pushStatus;
      this.dispatchLoadSearch.stageType = searchCriteria.stageType;
      this.dispatchLoadSearch.filter = searchCriteria.filter;

      this.searchStage.loadKey = this.stageList[0].loadKey;

      this.searchDriverSearchReq.driverOffice = "STC";
      this.searchDriverSearchReq.defaultSalesOffice = "LGB";
      // this.$store.dispatch('gstDriverMaster', this.searchDriverSearchReq);
      // console.log("getGSTDriverMaster: " + JSON.stringify(this.getGSTDriverMaster));
      // await this.updateDrivers(this.getGSTDriverMaster); 

      // this.searchRequest.salesOffice = "LGB";
      // this.$el.querySelector('#expand-button').click();
      // console.log("searchStage loadKey: " + this.searchStage.loadKey);
      // if (this.searchStage.loadKey != null) this.searchRequest.loadKey = this.searchStage.loadKey;
      // const cachedSearchRequest = this.$store.state.dispatchStageList.searchRequest;
      // // if (cachedSearchRequest) {
      // //  this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
      // // }
      // this.$el.querySelector('#searchTag').click();
      // console.log("DispatchStageList");
      // this.updateItems(this.getDispatchStageList);

    

  },

   methods: {

    filterBar(){
      this.isFilterModalShowing = true;
    },

     handleOfficeChanged(id) {
      this.searchRequest.salesOffice = id;
    },

    sortFunction(sortFiled){
              const nullValues = _.filter(this.items, (item) => {
                return item[sortFiled] == null
              })
              const values = this.items.filter(it => it[sortFiled] != null);
              const sorted = _.sortBy(values,sortFiled).concat(nullValues);
              this.sortStatus = !this.sortStatus;
              if (this.sortStatus)
              {
                  this.items = sorted;
              }
              else
              {
                  this.items = sorted.reverse();
              }
        },



    handleWindowsChanged(id) {
      this.searchRequest.receivingWindow = id;
    },
    handleDrGroupChanged(id) {
      this.searchRequest.driverGroup = id;
    },
    handleStageStatusChanged(id) {
      this.searchRequest.stageStatus = id;
    },
    handleCtnrTypeChanged(id) {
      this.searchRequest.ctnrType = id;
    },
    handleFreightTypeChanged(id) {
        this.searchRequest.freightType = id;
    },
    
    toggleContainerCopy(element){
        this.containerCopy = true;
        setTimeout(() => {  this.containerCopy = false; }, 2000);
        var el = document.createElement('textarea');
        el.value = element;
        el.setAttribute('readonly', '');
        el.style = {position: 'absolute', left: '-9999px'};
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    },

    toggleDispatch(element) {
        alert("call to pop-up dispatch" + element);
    },

      updateItems(itemsSource) {
        var items = JSON.parse(JSON.stringify(itemsSource));
        items.forEach((it) => {
          it.backGroud = false;
          it.selected = false;
          it.editing = false;
        });
        this.items = items;
        if (this.notifyMessage != null)
        {
          this.notifyActive = true;
          
        }

     },

    getPhotoName(photo) {
        const photoName = decodeURI(photo.imgUrl.replace(/.*\//g, ""));
        return `${this.filePrefixForEachFile || ''}${photoName}`;
    },

    async updateDrivers(itemsSource) {
           
          //await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverSearchReq)
          await newAPIPost('/api/w/gstMasterData/driverMasterData', this.searchDriverSearchReq)
                 .then ( (driverinfo) => {
                    if (driverinfo) {
                        driverinfo.forEach( (it) => {
                            console.log("driver: " + it.shortId);
                            this.drivers.push(it.shortId + "(" + it.driverId + ")");
                            this.driverIds.push(it.driverId);
                            this.driverNames.push(it.userName);
                            this.driverContent.push(it.shortId + "(" + it.driverId + ")");
                        })
                    }
                 });
          console.log("drivers: [[" + this.drivers + "]]");
    },

    changeAsgDriverId(item) {
        var pushstatus = item.pushStatus;
        console.log("asg driver push status: " + item.pushStatus);
        //return (id, name, unit, weight, plate, trail) => {
        return (driver) => {  
          if (this.isAsgDriver == true) {
             //if (pushstatus && pushstatus != "C" && pushstatus != "R" && pushstatus != "REJ" && pushStatus != "P") {
                if (driver && driver != "")
                    pushstatus = "A";
                else
                    pushstatus = null;    
             //}
          }

          item.driverId = driver;

          item.pushStatus = pushstatus;

          console.log("driver Id in item: " + item.driverId);
          
        };
    },

    async toggleItemLink(item) {
        const logId = "DISPATCH";
        const imgType = "C";
        this.isPictureModalShowing = true;
        this.isLoading = true;
        //this.photos = (await api.post('/api/w/ccr/photo/getCCRPhoto', { logId: logId, imageType: imgType, imagePath: item.driverCntrImg }));
        this.photos = (await newAPIPost('/api/w/ccr/photo/getCCRPhoto', { logId: logId, imageType: imgType, imagePath: item.driverCntrImg }));
        console.log("photos length: " + this.photos.length);
        if (item.loadKey != null)
           this.photoZipFileName = `${logId}_${item.loadkey}.zip`;
        else
           this.photoZipFileName = `${logId}_` + imgType + `.zip`;
        this.filePrefixForEachFile = `${item.containerNo}-`;
        this.photoTitle = "Container Image";
        console.log(this.photos)

    },

    chkItemPushStatus(item) {
       if (item.pushStatus == "REJ" || item.pushStatus == "R" || item.pushStatus == "C" || item.pushStatus == "A" || item.pushStatus == "P") 
           return false;
        else 
           return true;  
    },

     onSelectDType(val) {
        console.log("Dispatch type: " + val);
        this.selectDType = val;
     },
     
     doSearch() {

     
        const {
        users,
        teams,
        salesOffice,
      } = this.searchRequest;
      this.active = false;

      console.log("search request-stageStatus: " + this.searchRequest.stageStatus);
      this.searchRequest.salesOffice = "LGB";
  
      this.searchRequest.type = "";
      this.$store.dispatch('loadDispatchStageList', this.searchRequest);

     },


    async doDeleteBooking(){
        const request = this.getSelectedItems[0];
        const data = {
          user: 'GST_SYSTEM',
          seqNo: request.seqNo,
          mode: "REMOVE"
        }
        //api.post("/api/w/DOs/WebAssignDoHeaderWithStage", data)
        newAPIPost("/api/w/DOs/WebAssignDoHeaderWithStage", data)
        .then(() => {
          this.$store.commit('clearApiError');
          this.doSearch();
        });
    },


     async doDeleteStage(){
      const request = this.getSelectedItems[0];
        console.log(request);
        const data = {
          companyOffice: "GST_" + request.salesOffice,
          loadKeyWithStageNo: request.loadKeyWithStageNo,
          type: request.type || "YY",
          loadKey: request.seqNo,
          action: "DELETE_STAGE",
        }
        if (request.loadKeyWithStageNo == null)
        {
          alert('There is no stage selected');
          return;
        }

        //api.post("/api/w/gst/WebCopyDeleteStage", data)
        newAPIPost("/api/w/gst/WebCopyDeleteStage", data)
        .then(() => {
          this.$store.commit('clearApiError');
          this.doSearch();
        });

     },

     async onfresh(id, ticket, mode, loads) {
       console.log(`${id} , ${ticket} , ${mode}`);
       this.notifyMessage =  null;

       switch(mode)
       {
         case 'STR':
            this.notifyMessage = `Load ${id} has been scaled tw with scale ticket: ${ticket}.`;
         break;

         case 'SWR':
            this.notifyMessage = `Load ${id} with scale ticket: ${ticket} has been scaled gw.`;
         break;

         case 'ASN':
            this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
         break;

         case 'UASN':
            this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
         break;

         default:
         break;
       }
    
       this.doSearch();
     },

     async doDeleteLoad(){
      const request = this.getSelectedItems[0];
        console.log(request);
        const data = {
          companyOffice: "GST_" + request.salesOffice,
          loadKeyWithStageNo: request.loadKeyWithStageNo,
          type: request.type || "YY",
          loadKey: request.seqNo,
          action: "DELETE_LOAD",
        }

        //api.post("/api/w/gst/WebCopyDeleteStage", data)
        newAPIPost("/api/w/gst/WebCopyDeleteStage", data)
        .then(() => {
          this.$store.commit('clearApiError');
          this.doSearch();
        });

     }, 


     doClear(){
      this.filter = "";
     
      _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
        .each((it) => {
          it.click();
        });
    this.$nextTick(() => {
        this.searchRequest = getInitSearch();
        this.searchRequest.salesOffice = 'LGB';

      });

     },

     editDriverGroup() {
       this.isSetDriverGroup = true;
       this.disableSave = false;
     },

  
     editAppt() {
       this.disableAppt = false;
       this.disableSave = false;
     },

     async doChange(){
       
      const request = this.getSelectedItems[0];
        if (request.loadKeyWithStageNo == null)
        {
          alert('There is no stage selected');
          return;
        }

        if (request.stageStatus == 'STC' || request.stageStatus == 'SUC'  )
        {
          alert('The stage has been confirmed or under check, it can not be changed this time!');
          return;
        }

        this.$refs.DispatchFormChange.openDialog(request);

  },


  async doCopy(){
      const request = this.getSelectedItems[0];
        if (request.loadKeyWithStageNo == null)
        {
          alert('There is no stage selected');
          return;
        }

        this.$refs.DispatchFormCopy.openDialog(request);

  },

  doDispatch(){
      do {
          this.selectedItems.pop();
      } while (this.selectedItems.length > 0)
      console.log("selectedItems length: " + this.selectedItems.length);
      var items = this.items.forEach( it => {
        if (it.selected == true)
        {
          console.log("selected: " + it.selected);
          this.selectedItems.push(it);
        }
      })
      console.log("dispatch items: " + JSON.stringify(this.selectedItems));
      const request = this.selectedItems[0];
      this.$refs.DispatchFormCopy.openDialog(request);

  },

  doSingleDispatch(item){
      console.log("single dispatch item: " + JSON.stringify(item));

      if (item.loadKey == null)
         item.loadKey = item.seqNo;
      this.singleReq.push(item);    
      this.$router.push({  
            name: "cockpit" , 
            params: { req: JSON.stringify(this.singleReq) }
      })

  },

  getMasterDataByName(group, tagId) {
      if (!tagId) {
        return "";
      }
      return this.getMasterDataName(group, tagId);

  },

  handleTypeChanged(id) {
      this.searchRequest.type = id;
    },


  
  handleCarrierChanged(id) {
      this.searchRequest.carrier = id;
    },


  handleDriverRequestChanged(id) {
      this.searchRequest.driver = id;
    },



     handlePickLocationChanged(item) {
      return (pickupLocation) => {
        if (pickupLocation) {
          item.pickupLocationCode = pickupLocation.tagId;
          item.pickUpLocationName = pickupLocation.tagName;
          // item.pickUpLocation = pickupLocation;
        } else {

        }
      };
    },



    handleDeliverLocationChanged(item) {
      return (pickupLocation) => {
        if (pickupLocation) {
          item.deliverLocationCode = pickupLocation.tagId;
          item.deliverLocationName = pickupLocation.tagName;
          // item.pickUpLocation = pickupLocation;
        } else {

        }
      };
    },

    handlePushStatusChanged(id) {
      this.searchRequest.pushStatus = id;
    },
    

    doCockPit() {
      const request = this.uniqByLast(this.getSelectedItems, it => it.seqNo);
          //console.log(request);
          request.forEach((it) => {
            it.mode = 'YY';
            //it.carrierName = "";
            //it.customerPO = "";
            it.route = "";
            //it.deliveryOrder = "";
            if (it.loadKey == null)
            {
              it.loadKey = it.seqNo;
            }
          });
          this.searchCriteria.containerNo = this.searchRequest.containerNo;
          this.searchCriteria.receivingWindow = this.searchRequest.receivingWindow;
          this.searchCriteria.salesOffice = this.searchRequest.salesOffice;
          this.searchCriteria.pickupLocation = this.searchRequest.pickupLocation;
          this.searchCriteria.bookingNo = this.searchRequest.bookingNo;
          this.searchCriteria.destination = this.searchRequest.destination;
          this.searchCriteria.appointment = this.searchRequest.appointment;
          this.searchCriteria.driver = this.searchRequest.driver;
          this.searchCriteria.driverGroup = this.searchRequest.driverGroup;
          this.searchCriteria.costRelevant = this.searchRequest.costRelevant;
          this.searchCriteria.freightType = this.searchRequest.freightType;
          this.searchCriteria.loadKey = this.searchRequest.loadKey;
          this.searchCriteria.source = this.searchRequest.source;
          this.searchCriteria.chassisNo = this.searchRequest.chassisNo;
          this.searchCriteria.carrier = this.searchRequest.carrier
          this.searchCriteria.customerOrder = this.searchRequest.customerOrder;
          this.searchCriteria.deliveryOrder = this.searchRequest.deliveryOrder;
          this.searchCriteria.doProcess = this.searchRequest.doProcess;
          this.searchCriteria.loadStatus = this.searchRequest.loadStatus;
          this.searchCriteria.pushStatus = this.searchRequest.pushStatus;
          this.searchCriteria.stageType = this.searchRequest.stageType;
          this.searchCriteria.moveInDate.startDate = this.searchRequest.moveInDate.startDate;
          this.searchCriteria.moveInDate.endDate = this.searchRequest.moveInDate.endDate;
          this.searchCriteria.cargoCutOff.startDate = this.searchRequest.cargoCutOff.startDate;
          this.searchCriteria.cargoCutOff.endDate = this.searchRequest.cargoCutOff.endDate;
          this.searchCriteria.apptDate.startDate = this.searchRequest.apptDate.startDate;
          this.searchCriteria.apptDate.endDate = this.searchRequest.apptDate.endDate;
          this.searchCriteria.fromPage = "S";
          console.log("request for Load/Stage Detail: " + JSON.stringify(request));
          //request.push(this.searchCriteria);
          this.$router.push({  
            name: "Load/Stage Detail" , 
            params: { req: JSON.stringify(request), searchCriteria: JSON.stringify(this.searchCriteria)}})

    },

    getChassisUsedDate(item){
        if (item.chzEndDate == null)
        {
          return moment().diff(moment(item.chzStartDate), 'days')
        }
        else
        {
          return moment(item.chzEndDate).diff(moment(item.chzStartDate), 'days')
        }
    },

    getPushStatusInfo(status) {
     var retStatus = "";
     console.log("push status: " + status);
     if (status && status != "") {
        //retType = this.getMasterDataName("STC_STAGE_TYPE",type);
        retStatus = this.getMasterDataName("PUSH_STATUS",status);
        console.log("return type: " + retStatus);
     }
     return retStatus;     
  },

    async doOutGate(){
        const request = this.getSelectedItems;
        if (request.filter(it => it.stageType == "OUT" || it.stageType == null).length != 0)
        {
          alert("Can not out gate for this item!");
          return 
        }
        const data = request.map(it => ({
          salesOffice: it.salesOffice,
          user: it.user,
          type: it.type,
          appointment: it.appointment,
          apptDate: dateFormat.getLocalDate(it.apptDate),
          //pickupDate: dateFormat.getLocalDate(it.pickupDate),
          driverId: it.driverId,
          truckId: it.truckId,
          chassisStartDate :dateFormat.getLocalDate(moment())
        }));


        //await api.post("/api/w/gst/WebYardGroupOutGate", data)
        await newAPIPost("/api/w/gst/WebYardGroupOutGate", data)
        .then(() => {
          this.$store.commit('clearApiError');

        });
        this.doSearch();

    },


    doDownloadExcel(){
     const request = toGenerateExcelRequest(
        this.$el.querySelector('.data-table-container .inner-container'),
        'Dispatch-Stage-List.xls',
        1,
      );
        //request.heads = _(request.heads).take(52);
        request.heads = _(request.heads).take(38);
        request.rows = _(this.items)
        .map(item => [
          item.salesOffice,
          item.receivingWindow,
          item.loadStatus,
          item.stageStatus,
          item.containerNo,
          item.chassisNo,
          item.carrier,
          item.stage,
          item.stageType,
          item.freightType,
          item.costRelevant,
          item.dispatcherInstruction,
          item.bookingNo,
          item.cutLFD,
          item.dropOffTml,
          item.appointment,
          dateFormat.date(item.apptDate),
          dateFormat.time(item.apptDate),
          item.driverGroup,
          item.driverId,
          item.containerImg,
          this.getPushStatusInfo(item.pushStatus),
          item.ctnrType,
          item.source,
          this.getChassisUsedDate(item),
          dateFormat.date(item.chzEndDate),
          item.loadKey,
          item.yardLoc,
          item.customerOrder,
          item.sealNo,
          item.weightTicket,
          this.getMasterDataByName("GST_LOCATION",item.pickupLocationCode),
          item.pickUpTml,
          item.deliveryTo,
          item.truckId,
          item.dispatchInstuction,
          item.deliveryOrder,
          item.route, 
        ]);
      this.$store.dispatch('generateExcel', request)
        .then((res) => {
          window.open(res.url, 'blank');
        });
    },


    hasBeenChanged(item) {

      const lhs = _(this.getYardExportList)
        .find(it => it.vueKey === item.vueKey);
      
      if (lhs) {
        return (moment(lhs.apptDate).format() !== moment(item.apptDate).format())
          || (lhs.driverGroup !== item.driverGroup)
          || (lhs.appointment !== item.appointment)
          || (lhs.driverId !== item.driverId)
          || (lhs.truckId !== item.truckId)
          || (lhs.dispatcherInstruction !== item.dispatcherInstruction)
          || (lhs.costRelevant !== item.costRelevant)
          || (lhs.freightType !== item.freightType)
          || (lhs.pickupLocationCode != item.pickupLocationCode)
          || (lhs.deliverLocationCode != item.deliverLocationCode);
      }
      return false;
    },

   changeSelChkBox() {
      console.log("change check box: " + this.selectAll);
      console.log("yard export list: " +  JSON.stringify(_(this.items)));
      _(this.items).forEach(
        it => {
          it.selected = this.selectAll;
        }
      );
   },

   handleDriverChanged(item) {
      return (id) => {
        item.driverId = id;
      };
    },


      async CreateIngate(){
          const selectedItem = this.getSelectedItems[0];
          this.$refs.DispatchForm.openDialog(selectedItem);

      },

    toggleCreateIngate(item) {
     
      if (!!_(this.getEditingItems).find(it => !!this.hasBeenChanged(it)))
      {
          alert("Please save stages changes first!!");
        return;
      }

      if (item.bookingNo != null) return 

      this.$refs.CreateIngate.openDialog(item);

    },


    toggleInstruction(item) {

      if (item.editing == false)
      return 

      this.$refs.Instruction.openDialog(item);
    },

      getChassisUsedDate(date){
          return moment().diff(moment(date), 'days')

      },



      mouseOver: function(){
          this.active = true;
      },

      mouseLeave: function() {
       
        this.active = !this.active;
      },


      getDriverName(item){
          const driver = this.drivers.filter(it => it.id == item);
        
          return  driver.length == 0 ? "" : driver[0].name
      },


    handleScroll(e) {
      $(this.$el.querySelector('.table-header'))
        .offset({
          left: -1 * (e.target.scrollLeft - $('.outer-container')
            .offset().left),
        });
    },


    uniqByLast(data, key){
      return [
        ...new Map(
          data.map(x => [key(x), x])
        ).values()
      ]
    },


    includeNull(field){
          return field==null ? '' : field;
    },

    isValidCond(values) {
       if (values == null) return false;
       if (values[0])
          return (values.length === 1 && values[0].toString() != "");
       else
          return false;   
    }
    

   },

  }
</script>